module.exports = __webpack_public_path__ + "media/images/flags/SL-fb4ea22376a99c8aaa4f776c4199a824.svg";